import { ISlot as OriginalISlot } from "@gettactic/api";

// TBD: Investigate if this is the correct type for ISlot
export interface ISlot extends OriginalISlot {
  has_checked_in?: boolean;
  has_checked_out?: boolean;
}

export const getReservationDataFromSlot = (targetSlot: ISlot) => {
  let renderCheckIn = false;
  if (targetSlot) {
    const allowCheckIn =
      !!targetSlot?.capabilities?.can_respond_presence_check_in;
    const allowCheckOut =
      !!targetSlot?.capabilities?.can_respond_presence_check_out;
    const canRespondCancel = !!targetSlot?.capabilities?.can_respond_cancelled;
    const hasCheckedIn = !!targetSlot?.has_checked_in;
    const hasCheckedOut = !!targetSlot?.has_checked_out;

    const checkOutTime = targetSlot?.check_out_time;
    const checkInCheckOutDisabled: boolean = !allowCheckIn && !allowCheckOut;
    const canRespondPresence = !!targetSlot?.capabilities?.can_respond_presence;
    const canRespondPresenceRemote =
      !!targetSlot?.capabilities?.can_respond_presence_remote;
    const canRespondPresenceInPerson =
      !!targetSlot?.capabilities?.can_respond_presence_in_person;
    const canEdit = targetSlot?.capabilities?.can_edit;
    renderCheckIn = !checkInCheckOutDisabled;
    return {
      renderCheckIn,
      slotId: targetSlot?.id,
      allowCheckIn,
      allowCheckOut,
      canEdit,
      canRespondCancel,
      hasCheckedIn,
      hasCheckedOut,
      checkInCheckOutDisabled,
      checkOutTime,
      canRespondPresence,
      canRespondPresenceRemote,
      canRespondPresenceInPerson
    };
  }
  return {};
};
